import { useMutation } from '@tanstack/react-query';
import type { z } from 'zod';

import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';
import { generateRecommendedPetitionAngles } from 'src/app/pages/startAPetitionV2/shared/api';

import type { schema } from '../../schema';

type FormData = z.infer<typeof schema>;

export function useGenerateAiRecommendations() {
	const { data, actions } = useStartAPetitionPageState();
	const track = useTracking();
	const utilityContext = useUtilityContext();

	const { mutate, error, ...mutationState } = useMutation({
		mutationFn: async (formData: FormData) => {
			const input = { mainPrompt: data.draft?.input?.issuePrompt ?? '', personalStory: formData.personalStory };

			return generateRecommendedPetitionAngles(input, utilityContext);
		},
		onMutate: (formData) => {
			void track('sap_personal_story_submit', { personal_story: formData.personalStory });
		},
		onSuccess: (recommendations) => {
			actions.send({
				type: 'submit',
				draft: { input: { recommendations } },
			});
		},
	});

	return { mutate, error, mutationState };
}
